import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-club-green text-club-canvas pt-16 pb-8" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-168">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-169">
            <div data-id="element-170">
              <span className="font-serif text-xl sm:text-2xl font-semibold tracking-wide uppercase block" data-id="element-171">
                Andhra Social & Cultural Association
              </span>
              <span className="text-[0.65rem] tracking-[0.3em] text-club-gold uppercase" data-id="element-172">
                Chennai
              </span>
            </div>
            <p className="text-club-canvas/70 text-sm leading-relaxed" data-id="element-173">
              A premier institution dedicated to the social and cultural
              enrichment of the Andhra community in Chennai since 1999.
            </p>
            <div className="flex space-x-4" data-id="element-174">
              <a href="#" className="text-club-canvas/70 hover:text-club-gold transition-colors" data-id="element-175">
                <Instagram size={20} data-id="element-176" />
              </a>
              <a href="#" className="text-club-canvas/70 hover:text-club-gold transition-colors" data-id="element-177">
                <Facebook size={20} data-id="element-178" />
              </a>
              <a href="#" className="text-club-canvas/70 hover:text-club-gold transition-colors" data-id="element-179">
                <Twitter size={20} data-id="element-180" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-181">
            <h4 className="font-serif text-lg mb-6 text-club-gold" data-id="element-182">Explore</h4>
            <ul className="space-y-3" data-id="element-183">
              {['About the Club', 'Facilities', 'Dining & Bars', 'Sports & Wellness', 'Banquets & Events', 'Accommodation'].map(item => <li key={item} data-id="element-184">
                  <Link to={`/${item.split(' ')[0].toLowerCase()}`} className="text-sm text-club-canvas/70 hover:text-white transition-colors" data-id="element-185">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Member Services */}
          <div data-id="element-186">
            <h4 className="font-serif text-lg mb-6 text-club-gold" data-id="element-187">Members</h4>
            <ul className="space-y-3" data-id="element-188">
              {[{
              label: 'Member Login',
              to: '/members/login'
            }, {
              label: 'Information to Members',
              to: '/members/information'
            }, {
              label: 'Affiliated Clubs',
              to: '/affiliated-clubs'
            }, {
              label: 'Committee',
              to: '/committee'
            }, {
              label: 'Club Rules & Policies',
              to: '/policies'
            }, {
              label: 'Member Services',
              to: '/members'
            }].map(item => <li key={item.label} data-id="element-189">
                  <Link to={item.to} className="text-sm text-club-canvas/70 hover:text-white transition-colors" data-id="element-190">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-191">
            <h4 className="font-serif text-lg mb-6 text-club-gold" data-id="element-192">Contact</h4>
            <ul className="space-y-4" data-id="element-193">
              <li className="flex items-start gap-3 text-sm text-club-canvas/70" data-id="element-194">
                <MapPin size={18} className="shrink-0 text-club-gold mt-0.5" data-id="element-195" />
                <span data-id="element-196">
                  22, Vijayaraghava Rd, Lakshmi Colony,
                  <br data-id="element-197" />
                  T. Nagar, Chennai 600017 (Behind Residency Hotel)
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-club-canvas/70" data-id="element-198">
                <Phone size={18} className="shrink-0 text-club-gold" data-id="element-199" />
                <span data-id="element-200">+91 44 2815 3052</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-club-canvas/70" data-id="element-201">
                <Mail size={18} className="shrink-0 text-club-gold" data-id="element-202" />
                <span data-id="element-203">info@andhraassociation.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-club-canvas/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-204">
          <p className="text-xs text-club-canvas/50" data-id="element-205">
            &copy; {new Date().getFullYear()} Andhra Social & Cultural
            Association. All rights reserved.
          </p>
          <div className="flex space-x-6 text-xs text-club-canvas/50" data-id="element-206">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-207">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-208">
              Terms of Service
            </Link>
            <Link to="/admin/login" className="hover:text-white transition-colors" data-id="element-209">
              Staff Login
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}